/**
 * Scrolls to the given element.
 * If the given element is a string, it will be used as an id to find the element.
 */
export function scrollTo(element: HTMLElement | string, mode: ScrollBehavior = 'smooth'): void {
  if (typeof element === 'string') {
    element = document.getElementById(element)!;
  }

  element?.scrollIntoView({ behavior: mode });
}
